class FilterResultVM extends BaseResultVM {
    dataTable: [][];
    filter: Filter;

    valuesSelectedTitleText: KnockoutObservable<string>;
    editorTypeChanging: boolean = false;
    conditionChanging: boolean = false;

    constructor(data) {
        super(data);

        this.dataTable = data.dataTable;
        this.filter = new Filter(data.filter ?? { }, this.dataTable);

        this.valuesSelectedTitleText = ko.observable("");
    }
}